import { render, staticRenderFns } from "./IllustrationNavigation.vue?vue&type=template&id=6834fbb4&scoped=true&"
import script from "./IllustrationNavigation.vue?vue&type=script&lang=js&"
export * from "./IllustrationNavigation.vue?vue&type=script&lang=js&"
import style0 from "./IllustrationNavigation.vue?vue&type=style&index=0&id=6834fbb4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6834fbb4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/Kristian/Local Sites/boligvelger/app/public/wp-content/plugins/ensign-boligprosjekter-blocks/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6834fbb4')) {
      api.createRecord('6834fbb4', component.options)
    } else {
      api.reload('6834fbb4', component.options)
    }
    module.hot.accept("./IllustrationNavigation.vue?vue&type=template&id=6834fbb4&scoped=true&", function () {
      api.rerender('6834fbb4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/IllustrationNavigation.vue"
export default component.exports